// A touch screen (an iPad, an Android tablet, a phone): the primary pointer is a finger.
// There, focusing a text field brings up the keyboard over half the screen — and on an
// iPad it takes the page out of full screen (`components/fullscreen/`) — so a screen
// never focuses a field on its own: the operator taps it when they mean to type.

export function touchScreen(): boolean {
  return typeof window.matchMedia === 'function' && window.matchMedia('(pointer: coarse)').matches;
}
